import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { DeviceConfigurerServiceLogModule } from './log/log.module';
import { DeviceConfigurerServiceApplicationArtatechModule } from './application/application-artatech.module';
import { DeviceConfigurerServiceDeviceModule } from './device/device.module';
import { DeviceConfigurerServiceImageResourceModule } from './image-resource/image-resource.module';
import { DeviceConfigurerServiceModelModule } from './model/model.module';
import { DeviceConfigurerServiceModelImageModule } from './model-image/model-image.module';
import { DeviceConfigurerServiceResourceModule } from './resource/resource.module';
import { DeviceConfigurerServiceSellerModule } from './seller/seller.module';
import { DeviceConfigurerServiceFeedModule } from './feed/feed.module';
/* jhipster-needle-add-entity-module-import - JHipster will add entity modules imports here */

@NgModule({
    imports: [
        DeviceConfigurerServiceLogModule,
        DeviceConfigurerServiceApplicationArtatechModule,
        DeviceConfigurerServiceDeviceModule,
        DeviceConfigurerServiceImageResourceModule,
        DeviceConfigurerServiceModelModule,
        DeviceConfigurerServiceModelImageModule,
        DeviceConfigurerServiceResourceModule,
        DeviceConfigurerServiceSellerModule,
        DeviceConfigurerServiceFeedModule,
        /* jhipster-needle-add-entity-module - JHipster will add entity modules here */
    ],
    declarations: [],
    entryComponents: [],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeviceConfigurerServiceEntityModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity.module.ts